import axios from 'axios'
import BASE_URL from '@/config/api.js'


const HEALTH_URL = BASE_URL + "/"


class HealthResource {
    
    getHealthAnd(action) {
        // Return the object to possibly handle the error
        return axios.get(HEALTH_URL)
            .then(() => action())
    }

}

const healthApi = new HealthResource()

export default healthApi
